import axios from "axios";
import React from "react";
import API from "config/Api";
import { AppCtx } from "data/context";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { Dialog } from "@headlessui/react";
import ShowMoreText from "react-show-more-text";
import TicketLayout from "components/ui/Ticket";
import { Button, DisplayIcon, Loading, Separate } from "components/ui";

interface Props {
  link: any;
}

const EventBooking: React.FC<Props> = ({ link }) => {
  const { setIsOpen } = React.useContext(AppCtx);
  const [logingData, setLogingData] = React.useState(false);
  const [eventDetails, setEventDetails] = React.useState<any>({});
  const [ticketDetails, setTicketDetails] = React.useState<any[]>([]);
  const [stepWiseData, setStepWiseData] = React.useState(true);
  const [selectedTicket, setSelectedTicket] = React.useState<any>({});
  const [promoCode, setPromoCode] = React.useState("");
  const [promoCodeDeatils, setpromoCodeDeatils] = React.useState<any>(null);
  const [quantity, setQuantity] = React.useState(1);
  const [isEventPayment, setIsEventPayment] = React.useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const fetchEventData = React.useCallback(() => {
    setLogingData(true);
    const authData = JSON.parse(localStorage.getItem("jd-u")!);
    const config = {
      headers: {
        Authorization: `Bearer ${authData?.token}`,
      },
    };
    const url = API + `getEventByLinkId/${link?._id}`;
    axios
      .get(url, config)
      .then((response) => {
        if (response.data.success) {
          setEventDetails(response?.data?.data);
          setTicketDetails(response?.data?.data?.event_ticket);
        }
      })
      .catch((err) => {
        console.log("error here", err.response);
      })
      .finally(() => {
        setLogingData(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [link?._id]);

  const onNextStep = () => {
    if (selectedTicket?.ticketName === undefined) {
      toast.warning("Youe have to select atleast one ticket.");
    } else {
      setStepWiseData(!stepWiseData);
    }
  };

  const onClose = () => {
    setIsOpen(false);
  };

  const isValidEmail = (mail: any) =>
    // eslint-disable-next-line no-useless-escape
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      mail
    );

  const handleEmailValidation = (mail: any) => {
    const isValid = isValidEmail(mail);
    const validityChanged =
      (errors.mail && isValid) || (!errors.mail && !isValid);
    if (validityChanged) {
      console.log("Fire tracker with", isValid ? "Valid" : "Invalid");
    }
    return isValid;
  };

  const onCheckPromo = () => {
    if (promoCode === "") {
      toast.warn("Please Enter Promo Code Before Applying.");
    } else {
      const body = {
        promoCode: promoCode,
      };
      const authData = JSON.parse(localStorage.getItem("jd-u")!);
      const config = {
        headers: {
          Authorization: `Bearer ${authData?.token}`,
        },
      };

      let url = API + `promo/check`;
      axios
        .post(url, body, config)
        .then((response) => {
          if (response?.data?.success) {
            setpromoCodeDeatils(response?.data?.data);
          } else {
            toast.warn("Promo Code Invalid.");
            setpromoCodeDeatils(null);
          }
        })
        .catch(function (error) {
          console.log("Error", error.message);
        });
    }
  };

  const onSelectTicket = (e: any) => {
    setSelectedTicket(e);
    setStepWiseData(!stepWiseData);
  };

  const onSubmit = handleSubmit((data: any) => {
    setIsEventPayment(true);
    const body = {
      qty: data?.quantity,
      email: data?.mail,
      mobile: data?.phone_no,
      amt: selectedTicket?._id,
      type: selectedTicket?.type,
      price: selectedTicket?.price,
      date: selectedTicket?.eventDate,
      valid: selectedTicket?.valid,
      promo_id: promoCodeDeatils?._id || null,
      user_link_id: link?._id,
      user_id: link?.user_id,
    };
    const authData = JSON.parse(localStorage.getItem("jd-u")!);
    const config = {
      headers: {
        Authorization: `Bearer ${authData?.token}`,
      },
    };
    const url = API + `event/order`;
    axios
      .post(url, body, config)
      .then((response) => {
        if (response.data.success) {
          window.location.href = response.data.data.payment_link;
          setIsOpen(false);
        } else {
          toast.warn(`${response?.data?.message}`);
        }
      })
      .catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log("Error", error.message);
        }
      })
      .finally(() => {
        setIsEventPayment(false);
      });
  });

  const percentageOff = (price: any, percentageValue: any, price2: any) => {
    return (
      parseFloat(price2) -
      parseFloat(price) * (parseFloat(percentageValue) / 100)
    );
  };

  const onPercentageOn = (price: any, percentageValue: any, price2: any) => {
    return (
      parseFloat(price2) +
      parseFloat(price) * (parseFloat(percentageValue) / 100)
    );
  };

  React.useEffect(() => {
    fetchEventData();
  }, [fetchEventData]);

  if (logingData) {
    return <Loading />;
  } else {
    return (
      <>
        <Dialog.Title
          as="h3"
          className="text-gray-900 pb-4 text-center text-xl font-medium leading-6"
        >
          {eventDetails?.event_name}
        </Dialog.Title>
        <Separate dark={true} />
        {stepWiseData ? (
          <>
            <div className="my-7">
              <div className="mx-auto mb-2 h-40 w-40 select-none">
                <DisplayIcon
                  height={36}
                  width={36}
                  icon={eventDetails?.link_id?.social_icon}
                />
              </div>
              <div className="ml-4 text-center">
                <ShowMoreText
                  lines={4}
                  more="Show more"
                  less="Show less"
                  className="text-sm"
                  expanded={false}
                  // width={100}
                  truncatedEndingComponent={"... "}
                >
                  {eventDetails?.event_description}
                </ShowMoreText>
              </div>
            </div>
            {ticketDetails.map((item, index) => {
              return (
                <div key={index}>
                  <TicketLayout
                    ticketData={item}
                    onClick={() => onSelectTicket(item)}
                  />
                  <div className="my-5 flex justify-end">
                    <button
                      className="w-fit rounded border bg-white px-3 py-1.5 shadow-xl"
                      onClick={() => onSelectTicket(item)}
                    >
                      Select Ticket
                    </button>
                  </div>
                </div>
              );
            })}
            <div className="my-5 sm:mx-auto sm:max-w-xs">
              <div className="flex justify-between">
                <button
                  type="button"
                  className="inline-flex w-32 select-none items-center justify-center rounded-md border border-raisin-black bg-transparent py-2 text-base font-medium leading-6 text-raisin-black shadow transition duration-150 ease-in-out"
                  onClick={onClose}
                >
                  Cancel
                </button>
                <Button type="submit" onClick={() => onNextStep()}>
                  Next
                </Button>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="my-7">
              {selectedTicket?.ticketName === undefined ? (
                <>
                  <div className="grid">
                    <div className="mb-3 text-center text-xl font-bold">
                      Select ticket first.
                    </div>
                    <button
                      onClick={onSelectTicket}
                      className="m-auto inline-flex w-32 select-none items-center justify-center rounded-md border border-raisin-black bg-transparent py-2 text-base font-medium leading-6 text-raisin-black shadow"
                    >
                      Select Ticket
                    </button>
                  </div>
                </>
              ) : (
                <>
                  <TicketLayout ticketData={selectedTicket} />
                </>
              )}

              <form className="mt-10 space-y-4" onSubmit={onSubmit}>
                <div className="mt-5 flex items-center rounded-md bg-cultured">
                  <div className="-mr-10 w-full pl-5 text-left font-medium text-raisin-black">
                    Quantity
                  </div>
                  <div className="w-full">
                    <input
                      className="flex w-full items-center justify-center rounded-md border-0 bg-cultured py-3 pr-5 text-right font-medium leading-6 text-raisin-black placeholder:font-normal placeholder:text-philippine-gray focus:outline-none focus:ring-0"
                      type="number"
                      placeholder="Quantity Ex:(4)"
                      {...register("quantity", {
                        onChange(event) {
                          setQuantity(event.target.value);
                        },
                        required: true,
                        min: 1,
                        max: 5,
                      })}
                    />
                  </div>
                </div>

                {errors.quantity && (
                  <p className="flex justify-end text-[#CC3300]">
                    This field is required.
                  </p>
                )}

                <div className="mt-5 flex items-center rounded-md bg-cultured">
                  <div className="-mr-10 w-full pl-5 text-left font-medium text-raisin-black">
                    Phone Number
                  </div>
                  <div className="w-full">
                    <input
                      className="flex w-full items-center justify-center rounded-md border-0 bg-cultured py-3 pr-5 text-right font-medium leading-6 text-raisin-black placeholder:font-normal placeholder:text-philippine-gray focus:outline-none focus:ring-0"
                      type="number"
                      placeholder="999-999-9999"
                      {...register("phone_no", {
                        required: true,
                        minLength: 10,
                        maxLength: 10,
                      })}
                    />
                  </div>
                </div>
                {errors?.phone_no?.type === "required" && (
                  <p className="flex justify-end text-[#CC3300]">
                    This field is required.
                  </p>
                )}
                {errors?.phone_no?.type === "minLength" && (
                  <p className="flex justify-end text-[#CC3300]">
                    Phone number should be in 10 digits.
                  </p>
                )}
                {errors?.phone_no?.type === "maxLength" && (
                  <p className="flex justify-end text-[#CC3300]">
                    Phone number should be in 10 digits.
                  </p>
                )}

                <div className="mt-5 flex items-center rounded-md bg-cultured">
                  <div className="-mr-10 w-full pl-5 text-left font-medium text-raisin-black">
                    Email
                  </div>
                  <div className="w-full">
                    <input
                      className="flex w-full items-center justify-center rounded-md border-0 bg-cultured py-3 pr-5 text-right font-medium leading-6 text-raisin-black placeholder:font-normal placeholder:text-philippine-gray focus:outline-none focus:ring-0"
                      type="mail"
                      placeholder="Email"
                      {...register("mail", {
                        required: true,
                        validate: handleEmailValidation,
                      })}
                    />
                  </div>
                </div>
                {errors.mail && (
                  <p className="flex justify-end text-[#CC3300]">
                    Please enter vaild mail id.
                  </p>
                )}
              </form>

              <div className="mt-5 flex items-center rounded-md bg-cultured p-2">
                <input
                  className="w-full border-0 bg-transparent"
                  type="text"
                  name="promoCode"
                  id="promoCode"
                  placeholder="Apply Promo Code"
                  onChange={(e) => setPromoCode(e.target.value)}
                />
                <button
                  className="w-44 select-none rounded-md border border-gold bg-gold px-3 py-2 font-medium capitalize text-raisin-black"
                  onClick={onCheckPromo}
                >
                  Apply
                </button>
              </div>
              <div className="mt-5 flex w-full items-center justify-between rounded-md bg-cultured p-4 lg:w-2/4">
                <div className="font-medium text-raisin-black">
                  <h2>Ticket Price:</h2>
                  <h2>Handling Charge:</h2>
                  {promoCodeDeatils !== null && <h2>Promo Code:</h2>}
                  <h2>Total:</h2>
                </div>
                <div className="text-right">
                  <h2>₹ {selectedTicket?.price}</h2>
                  {eventDetails?.payment_commission ? (
                    <>
                      <h2>{eventDetails?.commission_value} %</h2>
                      {promoCodeDeatils !== null ? (
                        <>
                          <h2>{promoCodeDeatils?.promoAmount} % Off</h2>
                          <h2>
                            ₹&nbsp;
                            {(
                              percentageOff(
                                onPercentageOn(
                                  selectedTicket?.price,
                                  eventDetails?.commission_value,
                                  selectedTicket?.price
                                ),
                                promoCodeDeatils?.promoAmount,
                                onPercentageOn(
                                  selectedTicket?.price,
                                  eventDetails?.commission_value,
                                  selectedTicket?.price
                                )
                              ) * quantity
                            ).toFixed(2)}
                          </h2>
                        </>
                      ) : (
                        <h2>
                          ₹&nbsp;
                          {(
                            onPercentageOn(
                              selectedTicket?.price,
                              eventDetails?.commission_value,
                              selectedTicket?.price
                            ) * quantity
                          ).toFixed(2)}
                        </h2>
                      )}
                    </>
                  ) : (
                    <>
                      <h2>0 %</h2>
                      {promoCodeDeatils !== null ? (
                        <>
                          <h2>{promoCodeDeatils?.promoAmount} % Off</h2>
                          <h2>
                            ₹&nbsp;
                            {percentageOff(
                              selectedTicket?.price,
                              promoCodeDeatils?.promoAmount,
                              selectedTicket?.price
                            )}
                          </h2>
                        </>
                      ) : (
                        <h2>
                          ₹&nbsp;
                          {(parseInt(selectedTicket?.price) * quantity).toFixed(
                            2
                          )}
                        </h2>
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className="my-5 sm:mx-auto sm:max-w-xs">
                <div className="flex justify-between">
                  <Button onClick={onNextStep}>Previous</Button>
                  <Button onClick={onSubmit} loading={isEventPayment}>
                    Pay
                  </Button>
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
};

export default EventBooking;
